export default __webpack_public_path__ + "static/media/home-profile.cd42f7d1.png";